import { NgModule } from '@angular/core';

import { RenderEventsService } from './render-events.service';


@NgModule({
  providers: [
    RenderEventsService
  ]
})
export class RenderEventsModule {}
